export default __webpack_public_path__ + "static/media/mastercard-logo.089eb5bb.png";